/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import ReplayCircleFilled from '@mui/icons-material/ReplayCircleFilled';
import { Alert, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import useCWPContext from '../context/useCWPContext';

function Table() {
  //
  const {
    auth,
    activeTab,
    cwpData,
    loading,
    handleUpdateAll,
    handleViewAppointments,
    rowsSelected,
    setRowsSelected,
    handleViewSelected,
    handleRecoverAll,
  } = useContext(useCWPContext);

  const managerColumn =
    auth.designation === 'admin'
      ? [
          {
            field: 'manager_name',
            flex: 1,
            headerName: 'Manager Name',
            width: 200,
          },
        ]
      : [];

  let actionButton;
  if (activeTab === 0 || (activeTab === 1 && auth.designation === 'admin')) {
    actionButton = [
      {
        field: 'action',
        flex: 1,
        headerName: 'Action',
        width: 200,
        renderCell: ({ row }) => (
          <div>
            <Button
              size='small'
              variant='contained'
              color='success'
              onClick={(e) => handleUpdateAll(row, 1, true)}
              startIcon={<CheckIcon />}
            >
              Approved
            </Button>
            &nbsp;
            <Button
              size='small'
              variant='contained'
              color='error'
              onClick={(e) => handleUpdateAll(row, 3, true)}
              startIcon={<DeleteIcon />}
            >
              Reject
            </Button>
          </div>
        ),
      },
    ];
  } else if (activeTab === 3 && auth.designation === 'admin') {
    // for recently deleted in rejected tab

    actionButton = [
      {
        field: 'action',
        flex: 1,
        headerName: 'Action',
        width: 200,
        renderCell: ({ row }) => (
          <div>
            {row.recent_deleted === 1 && (
              <Button
                size='small'
                variant='contained'
                color='secondary'
                onClick={(e) => handleRecoverAll(row, row.status_id, true)}
                startIcon={<ReplayCircleFilled />}
              >
                Recover
              </Button>
            )}
          </div>
        ),
      },
    ];
  } else {
    actionButton = [];
  }

  const statusColumn =
    activeTab === 2 || activeTab === 3
      ? [
          {
            field: 'status_by',
            flex: 1,
            headerName: activeTab === 2 ? 'Approvers Name' : 'Rejected By',
            width: 200,
          },
          {
            field: 'status_date',
            flex: 1,
            headerName: activeTab === 2 ? 'Date Approved' : 'Date Rejected',
            width: 200,
          },
        ]
      : [];

  let actionAllButton = null;
  if (rowsSelected.length > 0 && activeTab !== 3) {
    actionAllButton = (
      <>
        &nbsp;
        <Button
          size='small'
          variant='contained'
          color='error'
          sx={{ float: 'right' }}
          onClick={() => handleViewSelected('Reject')}
          startIcon={<DeleteIcon />}
        >
          Reject All Selected
        </Button>
        &nbsp;
        <Button
          size='small'
          variant='contained'
          color='success'
          sx={{ float: 'right', marginRight: '10px' }}
          onClick={() => handleViewSelected('Approve')}
          startIcon={<CheckIcon />}
        >
          Approve All Selected
        </Button>
      </>
    );
  } else if (rowsSelected.length > 0 && activeTab === 3) {
    actionAllButton = (
      <>
        &nbsp;
        <Button
          size='small'
          variant='contained'
          color='success'
          sx={{ float: 'right', marginRight: '10px' }}
          onClick={() => handleViewSelected('Recover')}
          startIcon={<CheckIcon />}
        >
          Recover All Selected
        </Button>
      </>
    );
  } else {
    actionAllButton = [];
  }

  const columns = [
    {
      field: 'requested_by',
      flex: 1,
      headerName: 'Requestor Name',
      width: 200,
      renderCell: ({ row }) => (
        <div>
          <Button variant='text' onClick={() => handleViewAppointments(row?.ids)}>
            {row.requested_by}
          </Button>
        </div>
      ),
    },
    ...managerColumn,
    { field: 'md_name', flex: 1, headerName: 'MD Name', width: 200 },
    { field: 'date_requested', flex: 1, headerName: 'Date Submitted', width: 200 },
    { field: 'appointment_dates', flex: 1, headerName: 'Appointment Date', width: 200 },
    ...statusColumn,
    // ...actionButton,
  ];

  return (
    <Grid container spacing={2}>
      <Grid xs={8} sm={8} md={8}>
        {activeTab === 3 ? (
          <Alert severity='info'>Only those Recently Rejected can be recovered.</Alert>
        ) : (
          ''
        )}
      </Grid>
      <Grid xs={4} sm={4} md={4}>
        {actionAllButton}
      </Grid>
      <Grid xs={12} sm={12} md={12}>
        <Grid xs={12} sm={12} md={12}>
          {/* {rowsSelected.length > 0 ? (
            <Button
              size='small'
              variant='contained'
              color='error'
              sx={{ float: 'right' }}
              onClick={(e) => handleDeleteAllSelected(null, true)}
              startIcon={<DeleteIcon />}
            >
              Delete All Selected
            </Button>
          ) : (
            ''
          )} */}
        </Grid>
        <div className='table-container' style={{ height: '800px', marginLeft: '20px' }}>
          <DataGridPro
            rows={cwpData}
            columns={columns}
            loading={loading}
            checkboxSelection
            isRowSelectable={(params) => {
              if (activeTab === 3) {
                return params.row.recent_deleted;
              }
              return true;
            }}
            onSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selectedRows = cwpData.filter((row) => selectedIDs.has(row.id));

              setRowsSelected(selectedRows);
            }}
          />
        </div>
      </Grid>
    </Grid>
  );
}

export default Table;
